export default __webpack_public_path__ + "static/media/heroBanner.2a8428a8.png";